module.exports = __webpack_public_path__ + "img/structuredDeposits3.eb12465d.jpg";